import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { catchError, lastValueFrom,throwError } from 'rxjs';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class SyncConfigService {
  private appConfig;

  constructor (private injector: Injector, private http: HttpClient, private env: EnvironmentService) { }

  async loadAppConfig() {
    let http = this.injector.get(HttpClient);
    const jsonData = http.get('/assets/config/sync-config.json');
    this.appConfig = await lastValueFrom(jsonData);
  }

  sendTestEmail() {
    const url = this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "SyncConfiguration/TestEmail";

    const headers = new HttpHeaders()
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");

    return this.http.post(url, {}, { headers }).pipe(
      catchError(error => {
        return throwError(error); // Re-throw to let subscriber handle it
      })
    );
  }
  get config() {
      return this.appConfig;
  }
}

